import { render, staticRenderFns } from "./OrganizationEmailTable.vue?vue&type=template&id=dbfd5a2c&"
import script from "./OrganizationEmailTable.vue?vue&type=script&lang=ts&"
export * from "./OrganizationEmailTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports